import { InfoText as StyledInfoText } from './InfoText.styles';
import * as React from 'react';

export interface InfoTextProps {
  /**
   * Info text contents
   */
  label: string;
  size?: 'small' | 'regular' | 'large';
  color?: string;
}

/**
 * The main text contents of the page.
 */
export const InfoText: React.FC<InfoTextProps> = ({
  label,
  size,
  color,
}: InfoTextProps) => {
  return (
    <StyledInfoText size={size} color={color}>
      {label}
    </StyledInfoText>
  );
};

export default InfoText;
